export function getOptionType (option) {
  if (typeof option.isLatex === 'function' && option.isLatex()) {
    return 'latex'
  } else if (typeof option.isImage === 'function' && option.isImage()) {
    return 'image'
  } else {
    return 'text'
  }
}
